import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AccountAdminCenterService } from '../account-admin-center.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogCloseEvent } from '../../../const';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { HelperMethods } from '../../common/helper-methods.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DtoSector } from '../../../models/sector.model';
import * as XLSX from 'xlsx';
import { SchoolService } from '../../school/school.service';

@Component({
  selector: 'app-create-account-admin',
  templateUrl: './create-account-admin.component.html'
})
export class CreateAccountAdminComponent implements OnInit {

  
  resendActivation(){
    this.schoolService.resendActivationInvite(this.data.userId)
    .subscribe({
      next: (response: any) => {
        if(response.isSuccess===false)
          this.toasterService.error(`${this.data.userDetail.emailId}: ${response.message}`, "Resend Activation Invite");
        else
          this.toasterService.success(`Activation invite resent to ${this.data.emailId}`, "Resend Activation Invite");
      },
      error: (err: any) => {
        this.toasterService.error(`Activation invite could not be resent to ${this.data.emailId}`, "Resend Activation Invite");
      }
    });  
  }

  createUserForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]),
    phoneNumber: new FormControl('', 
    [this.helperMethods.PhoneNumberValidator()]),
    sector: new FormControl(null as number | null, [Validators.required])
  });
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  isEditUser: boolean = false;
  canEditUser: boolean = false;
  @ViewChild('uploadFileInput') uploadFileInput: ElementRef | undefined;
  selectedSubcategory: string | undefined; 
  selectedSubcategories: string[] = []; 
  subcategories: string[] = ['subCategory1', 'subCategory2', 'subCategory3']; 
  sectors: DtoSector[] = [];
  isActive: boolean = true;
  isAccountActivated: boolean = false;
  isBulkUpload : boolean = false;
  excelData: any[] = [];
  constructor(
    private accountAdminCenterService: AccountAdminCenterService,
    private toasterService: ToastrService,
    private dialog: MatDialog,
    private schoolService: SchoolService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<CreateAccountAdminComponent>,
    public helperMethods: HelperMethods
  ) {  }

  ngOnInit(): void {
    this.sectors = this.data.sectors;
    this.isActive = true;
    this.isAccountActivated = false;
    if(this.data.emailId){
      this.isEditUser = true;
      this.canEditUser = true;
      this.isActive = this.data.isActive;
      this.isAccountActivated = this.data.isAccountActivated;
      if(this.data.isBulkUploadEdit){
        this.isEditUser = false;
        this.canEditUser = false;
      }
      this.createUserForm.patchValue(this.data);
      this.createUserForm.controls['email'].setValue(this.data.emailId);
      let sectorList = this.data.sector && this.data.sector.length > 0 ? this.sectors.filter(x=> this.data.sector.map((y: DtoSector)=>y.sectorId).includes(x.sectorId)) : [];
      this.createUserForm.controls['sector'].setValue(sectorList);
      this.setPhoneNumber(this.data.countryCode?.toString(), this.data.phoneNumber.toString());
    }
    else{
      this.canEditUser = true;
      this.isEditUser = false;
    }
  }

  setPhoneNumber(countryCode: string, nationalNumber: string) {
    let examplePhoneNumber = `+${countryCode}${nationalNumber}`;
    let formattedNumber = this.phoneNumberUtil.format(
      this.phoneNumberUtil.parse(examplePhoneNumber),
      PhoneNumberFormat.INTERNATIONAL
    );
    this.createUserForm.patchValue({ phoneNumber: formattedNumber });
  }

  createUser(){
    let userDetails = JSON.parse(JSON.stringify(this.createUserForm.value));
    
    let parsedNumber = this.phoneNumberUtil.parse(this.createUserForm.get('phoneNumber')?.value);
        let countryCode = parsedNumber.getCountryCode();
        let nationalNumber = parsedNumber.getNationalNumber();

    userDetails.countryCode = countryCode;
    userDetails.phoneNumber = nationalNumber;
    userDetails.username = this.createUserForm.controls['firstName'].value.trim() + this.createUserForm.controls['lastName'].value.trim();

    if(this.data.isBulkUploadEdit)
    {
      this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, updatedDetails: userDetails} );
    }
    else if(this.isEditUser){
      this.accountAdminCenterService.editUser(userDetails).subscribe((response: any) => {
        if (response.isSuccess) {
          this.toasterService.success('User details updated successfully', 'Success');
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
    else{
      this.accountAdminCenterService.createUser([userDetails]).subscribe((response: any) => {
        if (response.isSuccess) {
          this.toasterService.success('User created successfully!', 'Success');
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
  }

  closePopup(){
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }

  bulkUpload(){
    if (this.uploadFileInput) {
      this.uploadFileInput.nativeElement.click();
    }
  }

  loadExcelData(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Assuming your data starts from the second row (index 1) 
      this.excelData = data.slice(1)
      .filter((row: any[]) => row.some(cell => cell !== undefined && cell !== null && cell !== ''))
      .map((row: any[]) => ({
        firstName: row[1] || '',
        lastName: row[2] || '',
        emailId: row[3] || '',
        countryCode: row[4] || '',
        phoneNumber: row[5] || '',
        sectorName: null // Sector to be added manually
      }));
    };
    reader.readAsBinaryString(target.files[0]);
    this.isBulkUpload = true;
    event.target.value = null;
  }

  areAllDetailsFilled(): boolean {
    return this.excelData.every(detail => 
      detail.firstName && 
      detail.lastName && 
      detail.emailId && 
      detail.countryCode && 
      detail.phoneNumber && 
      detail.sector
    );
  }

  openEditAccountAdminDialog(userDetail: any = {}, index: number){
    userDetail.sectors = this.sectors;
    userDetail.isBulkUploadEdit = true;
    this.dialog.open(CreateAccountAdminComponent, {
      width: '800px',
      data: userDetail || {}
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS && popupEvent?.updatedDetails){
          this.excelData[index].firstName = popupEvent?.updatedDetails.firstName;
          this.excelData[index].lastName = popupEvent?.updatedDetails.lastName;
          this.excelData[index].countryCode = popupEvent?.updatedDetails.countryCode;
          this.excelData[index].phoneNumber = popupEvent?.updatedDetails.phoneNumber;
          this.excelData[index].email = popupEvent?.updatedDetails.email;
          this.excelData[index].emailId = popupEvent?.updatedDetails.email;
          this.excelData[index].username = popupEvent?.updatedDetails.firstName.trim() + popupEvent?.updatedDetails.lastName.trim();

          let sectorList = this.sectors.filter(x=> popupEvent?.updatedDetails.sector.map((y: DtoSector)=>y.sectorId).includes(x.sectorId));
          this.excelData[index].sector = sectorList;
      }
    });
  }

  downloadFile(): void {
    const blobName = 'TemplateForBulkUploadAccountAdmin.xlsx'; // Specify the file name you want to download
    this.schoolService.downloadFile(blobName).subscribe((response: any) => {

      var url = response.blobUrl.toString();
      for (var i = 0; i < url.length; i++) {
        url = url.replace("~", "");
        url = url.replace("//", "%2F%2F");
        url = url.replace("/", "%2F");
        url = url.replace(":", "%3A");
    }
    console.log(url);
     var ViewDocumentUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
     window.open(ViewDocumentUrl, "_blank");
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }


  createBulkUsers(){
    this.accountAdminCenterService.createUser(this.excelData).subscribe((response: any) => {
      if (response.isSuccess) {
        this.toasterService.success('Users created successfully!', 'Success');
        this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  deleteItem(index: number): void {
      this.excelData.splice(index, 1);
  }
}
